module.exports = __webpack_public_path__ + "static/1_3_turing-test-76dd06f564bd7a92c4383db614e884ee.svg";